 
export async function loginKeychain(user) {
  return new Promise((resolve, reject) => {
    if (window.steem_keychain && user) {
      window.steem_keychain.requestSignBuffer(
        user,
        `{login: "${user}"}`,
        "Posting",
        (response) => {
          if (response.success) {
            resolve(response);
          } else {
            reject(response);
          }
        }
      );
    } else {
      reject({ success: false, message: "Steem Keychain not detected." });
    }
  });
}
// src/helpers/keychain.js
export async function addAccountAuthority(user, weight) {
  return new Promise((resolve, reject) => {
    if (window.steem_keychain && user) {
      window.steem_keychain.requestAddAccountAuthority(
        user,
        process.env.REACT_APP_AUTH_ACCOUNT,
        "Posting",
        weight,
        (response) => {
          if (response.success) {
            resolve(response);
          } else {
            resolve(response);
          }
        }
      );
    } else {
      reject({ success: false, message: "Steem Keychain not detected." });
    }
  });
}
